import axios from 'axios';
import * as csv from 'csvtojson';

// Function to transform the data given frorm Google to JSON
async function transformToJson(payload) {
  const csvRow = await csv().fromString(payload);
  return csvRow;
}

export default {
  state: {
    allSheetsData: false,
  },
  mutations: {
    getAllSheetsData(state, payload) {
      state.allSheetsData = payload;
    },
  },
  actions: {
    async fetchSheetData({ commit }) {
      let materials = await axios
        .get(
          'https://docs.google.com/spreadsheets/d/11Qvg-P0mIMdBBPktYLi-uslOsxJ8cQy87j6jRD_TOUA/export?format=csv&id=11Qvg-P0mIMdBBPktYLi-uslOsxJ8cQy87j6jRD_TOUA&gid=0',
        )
        .then(response => {
          return response;
        });
      let events = await axios
        .get(
          'https://docs.google.com/spreadsheets/d/11Qvg-P0mIMdBBPktYLi-uslOsxJ8cQy87j6jRD_TOUA/export?format=csv&id=11Qvg-P0mIMdBBPktYLi-uslOsxJ8cQy87j6jRD_TOUA&gid=508432501',
        )
        .then(response => {
          return response;
        });

      materials = await transformToJson(materials.data);
      events = await transformToJson(events.data);

      commit('getAllSheetsData', [...materials, ...events]);
    },
  },
};
